module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-left-circle-8811f7480ff7ba33ca029686a68ef0b2.svg";